"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Banner = function (_a) {
    var image = _a.image, textSmall = _a.textSmall, textBig = _a.textBig;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { style: { backgroundImage: "url(" + image + ")" }, className: 'banner-wrap' },
        react_1.default.createElement("span", null, t(textSmall)),
        textBig && react_1.default.createElement("h1", null, t(textBig))));
};
exports.default = Banner;
